import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import Project from '../../projects/Project';
import useQuery from './useQuery';

export default function Layout(props) {
  const { location } = useRouter();

  const PAGE_SIZE = 10;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Projects']}
      title="Completed"
      description={(
        <span>
          These are projects where an educator indicated they completed a project. CommunityShare
          recommends finding ways to publicize successful projects through media releases, social
          media, and presentations. Congratulating educators (and their supervisors) or partners (and
          their employers) after a successful project builds goodwill and momentum for
          community-engaged learning in your community.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function(project) {
        return (
          <Project key={project.id} project={project} />
        );
      }}
    />
  );
}
